import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=35b0381f"
import script from "./IconCross.vue?vue&type=script&lang=js"
export * from "./IconCross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports